import { useQueryClient } from "@tanstack/react-query";

import { rqClient } from "@/shared/api/instance";

export function useCreateDeposit() {
  const queryClient = useQueryClient();

  return rqClient.useMutation("post", "/api/v1/deposit_requests", {
    onSettled: async () => {
      await queryClient.invalidateQueries(
        rqClient.queryOptions("get", "/api/v1/deposit_requests", {}),
      );
      await queryClient.invalidateQueries(
        rqClient.queryOptions("get", "/api/v1/balance", {}),
      );
    },
  });
}
